import { css } from "styled-components";
import token from "styled-token";
import { disabledMixin } from "../disabledMixin";
import { spaceMixin } from "../spaceMixin";
import { spacingMixin } from "../spacingMixin";
import { autofillBackgroundMixin } from "../autofillBackgroundMixin";
import { StyledInput } from "../../components/Input/Input";
import { StyledAdornment, StyledAdornmentLeft, StyledAdornmentRight } from "../../components/Adornment/Adornment";

var leftCSS = function leftCSS(_ref) {
  var leftAdornment = _ref.leftAdornment;
  return leftAdornment ? css(["> ", "{padding-left:0;border-left:0;border-top-left-radius:0;border-bottom-left-radius:0;}"], StyledInput) : "";
};

var rightCSS = function rightCSS(_ref2) {
  var rightAdornment = _ref2.rightAdornment;
  return rightAdornment ? css(["> ", "{padding-right:0;border-right:0;border-top-right-radius:0;border-bottom-right-radius:0;}"], StyledInput) : "";
};

var errorCSS = function errorCSS(props) {
  var error = props.error;

  if (!error) {
    return "";
  }

  return token("Input.borderColorError", function (borderColor) {
    return css(["> ", "{&,&:hover:not([disabled]),&:active:not([disabled]),&:focus{& ~ ", "{border-color:", ";}}}"], StyledInput, StyledAdornment, borderColor);
  })(props);
};

var readOnlyLeftCSS = function readOnlyLeftCSS(props) {
  var leftAdornment = props.leftAdornment,
      readOnly = props.readOnly;

  if (!readOnly || !leftAdornment) {
    return "";
  }

  return css(["", "{padding-right:", ";}"], StyledAdornmentLeft, spaceMixin("sm")(props));
};

var readOnlyRightCSS = function readOnlyRightCSS(props) {
  var rightAdornment = props.rightAdornment,
      readOnly = props.readOnly;

  if (!readOnly || !rightAdornment) {
    return "";
  }

  return css(["", "{padding-left:", ";}"], StyledAdornmentRight, spaceMixin("sm")(props));
};
/** @class AdornedInputMixin */

/** @method */


export var AdornedInputMixin = function AdornedInputMixin(props) {
  var fluid = props.fluid;
  return token({
    backgroundColor: "Input.backgroundColor",
    backgroundColorAutofill: "Input.backgroundColorAutofill",
    backgroundColorInteractive: "Input.backgroundColorInteractive",
    borderColorInteractive: "Input.borderColorInteractive",
    borderColor: "Input.borderColor",
    borderRadius: "radii.md",
    focusBoxShadow: "shadows.focus"
  }, function (_ref3) {
    var backgroundColor = _ref3.backgroundColor,
        backgroundColorAutofill = _ref3.backgroundColorAutofill,
        backgroundColorInteractive = _ref3.backgroundColorInteractive,
        borderColorInteractive = _ref3.borderColorInteractive,
        borderColor = _ref3.borderColor,
        borderRadius = _ref3.borderRadius,
        focusBoxShadow = _ref3.focusBoxShadow;
    return css(["display:", ";> ", "{flex:0 0 auto;}> ", "{order:-1;}> ", "{min-width:0;&:-webkit-autofill ~ ", "{", "}&.edge-autofilled ~ ", "{background-color:", ";}&:active:not([disabled]),&:focus{& ~ ", "{background-color:", ";}}&:hover:not([disabled]),&:active:not([disabled]),&:focus{& ~ ", "{border-color:", ";}}&:focus{box-shadow:none;}&:focus:-webkit-autofill{", "}&[disabled] ~ ", "{", " &,&:hover,&:active,&:focus{background-color:", ";border-color:", ";}}&[readonly],&[readonly]:hover,&[readonly]:active,&[readonly]:focus{& ~ ", "{background-color:transparent;border-color:transparent;}}}&:focus-within{border-radius:", "px;box-shadow:", ";}", " ", " ", " ", " ", " ", ""], fluid ? "flex" : "inline-flex", StyledAdornment, StyledAdornmentLeft, StyledInput, StyledAdornment, autofillBackgroundMixin(props), StyledAdornment, backgroundColorAutofill, StyledAdornment, backgroundColorInteractive, StyledAdornment, borderColorInteractive, autofillBackgroundMixin(props), StyledAdornment, disabledMixin(Object.assign({}, props, {
      disabled: true
    })), backgroundColor, borderColor, StyledAdornment, borderRadius, focusBoxShadow, spacingMixin(props), leftCSS(props), rightCSS(props), errorCSS(props), readOnlyLeftCSS(props), readOnlyRightCSS(props));
  });
};